import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as classNames from 'classnames';
import { CircularProgress } from '@emburse/ui-core';
import '../../../../public/styles/abacons.styl';
import * as style from './Spinner.styl';
class Spinner extends React.Component {
    constructor(props) {
        super(props);
    }
    calculateSize(xsmall, small, medium, large) {
        if (xsmall)
            return 16;
        if (small)
            return 24;
        if (medium)
            return 32;
        if (large)
            return 48;
        return null;
    }
    render() {
        const { centered, xsmall, small, medium, large, usePrimaryColor } = this.props;
        const cssClasses = classNames('loader', {
            xsmall,
            small,
            medium,
            large,
            usePrimaryColor
        });
        let size = this.calculateSize(xsmall, small, medium, large);
        return (_jsx("div", Object.assign({ "data-testid": "Spinner", className: style.global + (centered ? ' centered' : '') }, { children: _jsxs("div", Object.assign({ className: cssClasses }, { children: [_jsx(CircularProgress, { size: size }), _jsx("span", Object.assign({ className: "loadingText" }, { children: this.props.loadingText }))] })) })));
    }
}
export { Spinner };
